/// <reference types="vite/client" />

const SW_URL = "/sw.js";

/**
 * Registers the offline-support service worker (see public/sw.js). Production
 * builds only: during `vite dev` the served files are unbundled and change on
 * every edit, so a caching service worker would fight the dev server instead of
 * helping - and there is no vite dev build for a real visitor to be offline for.
 *
 * Registered on `load` rather than immediately, so the service worker install
 * never competes with the page's own first paint/fetches for bandwidth.
 */
export function initServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    // updateViaCache: "none" keeps the HTTP cache out of the loop for sw.js itself,
    // so a redeploy is picked up on the browser's own update check instead of
    // possibly being served a long-cached, stale worker script.
    navigator.serviceWorker.register(SW_URL, { updateViaCache: "none" }).catch((err: unknown) => {
      console.error("Service Worker Registrierung fehlgeschlagen", err);
    });
  });
}
